import React from 'react'
import { Redirect } from 'react-router-dom'
import { Menu, Dropdown, Badge, Switch, Modal, Button, InputNumber, Icon } from 'antd'
import styles from './style.module.scss'
import { connect, settingsSetState, changeSelectedClinic } from '../../../../redux/index'

@connect(({ user, clinic, device, settings }) => ({ user, clinic, device, settings }))
class ProfileMenu extends React.Component {
  state = {
    count: 0,
    visibleSettingsModal: false,
    updatedDistance: undefined,
    redirectTo: false,
  }

  logout = () => {
    const { dispatch } = this.props
    sessionStorage.setItem('mLogout', 'true')
    dispatch({
      type: 'user/LOGOUT',
    })
  }

  addCount = () => {
    const { count } = this.state
    this.setState({
      count,
    })
  }

  changeClinic = (item) => {
    const { dispatch } = this.props
    const {
      location: { hash },
    } = window
    window.log('menu item clicked', item)
    dispatch(changeSelectedClinic(item))
    if (hash && hash !== '#/clinic/profile') {
      this.setState({ redirectTo: true })
    }
  }

  changeDistanceRange = () => {
    const { updatedDistance } = this.state
    if (updatedDistance) {
      const { dispatch } = this.props
      dispatch(settingsSetState({ distanceRange: updatedDistance }))
    }
    this.setState({
      visibleSettingsModal: false,
    })
    window.log('changeDistanceRange', updatedDistance)
  }

  handleCancelAdd = () => {
    this.setState({ visibleSettingsModal: false })
  }

  render() {
    const {
      user,
      settings: { isShowDistance, distanceRange /* , portalVersion */ },
    } = this.props
    const { role } = user
    const { visibleSettingsModal, redirectTo } = this.state
    const { count } = this.state
    if (redirectTo) {
      return <Redirect push to="/" />
    }
    const menu = (
      <Menu selectable={false}>
        <Menu.Item>
          <strong>Hello, {user.name || 'Anonymous'}</strong>

          <div>
            <strong>Role: </strong>
            {user.role}
          </div>
        </Menu.Item>

        {user.role !== 'Clinic' && <Menu.Divider />}
        <Menu.Item>
          <a href="javascript: void(0);" id="menu-logout" onClick={this.logout}>
            <i className={`${styles.menuIcon} icmn-exit`} />
            Logout
          </a>
        </Menu.Item>
      </Menu>
    )
    return (
      <React.Fragment>
        <Dropdown overlay={menu} trigger={['click']} onVisibleChange={this.addCount}>
          <div id="topbar-menu" className={styles.dropdown}>
            <Badge count={count}>
              {role !== 'Clinic' ? (
                <Icon
                  type="setting"
                  style={{
                    color: '#74708F',
                    fontSize: '18px',
                  }}
                />
              ) : (
                <Icon
                  type="setting"
                  style={{
                    color: '#74708F',
                    fontSize: '18px',
                  }}
                />
              )}
            </Badge>
          </div>
        </Dropdown>
        <Modal
          title={
            <React.Fragment>
              <h4>Presence</h4>
            </React.Fragment>
          }
          visible={visibleSettingsModal}
          onOk={this.changeDistanceRange}
          onCancel={this.handleCancelAdd}
          footer={[
            <Button key="submit" type="primary" onClick={() => this.changeDistanceRange()}>
              Save
            </Button>,
          ]}
          centered
        >
          <div className="row">
            <div className="col-6 text-center">
              <p style={{ marginTop: '1rem' }}>Display presence</p>
              <br />
              <Switch
                checked={isShowDistance}
                onClick={(value) => {
                  const { dispatch } = this.props
                  dispatch(settingsSetState({ isShowDistance: value }))
                }}
              />
            </div>
            <div className="col-6 text-center">
              <p style={{ marginTop: '1rem' }}>Presence detection range</p>
              <br />
              <InputNumber
                min={0}
                max={3.0}
                step={0.1}
                defaultValue={distanceRange}
                onChange={(value) => {
                  this.setState({ updatedDistance: value })
                }}
              />
            </div>
          </div>
        </Modal>
      </React.Fragment>
    )
  }
}

export default ProfileMenu
